import { useMsal } from '@/composables/auth/useMsal';

import type { SilentRequest, RedirectRequest } from '@azure/msal-browser';
import { InteractionStatus } from '@azure/msal-browser';

const getAccessToken = async (request: RedirectRequest | SilentRequest) => {
  const { instance, inProgress } = useMsal();

  try {
    const response = await instance.value.acquireTokenSilent({
      ...request,
    });
    return Promise.resolve(response?.accessToken);
  } catch (e) {
    if (
      inProgress.value !== InteractionStatus.None &&
      inProgress.value !== InteractionStatus.Startup
    ) {
      return Promise.reject(e);
    }
    try {
      await instance.value.loginRedirect(request);
    } catch (e) {
      return Promise.reject(e);
    }
  }
};

export { getAccessToken };
